import { hideLoading, showLoading } from 'redux-store/reducers/loading-reducer';
import { RESET_ALL as RESET_ON_LOGOUT } from 'redux-store/reducers/common-reducer';
import { validateChannelUrl } from 'modules/channels/reducers/channels';

import { createReducer } from 'utils/redux';
import { API, post } from 'utils/api';
import { __t, applyTranslations } from 'utils/language';

import type { ChannelForm } from 'types';

applyTranslations(require('./lightweight-profile-reducer.i18n.json'));

const RECEIVE_ERROR = 'lightweightProfile/RECEIVE_ERROR';
const RECEIVE = 'lightweightProfile/RECEIVE';
const RESET = 'lightweightProfile/RESET';

const { createLightweightInfluencerProfile: createLightweightInfluencerProfileEndpoint } = API.END_POINTS.INFLUENCERS;

const initialState = {
  profile: {},
  errorMessage: ''
};

function receiveError(data) {
  return {
    type: RECEIVE_ERROR,
    payload: {
      data
    }
  };
}

function receiveLightweightProfile(data) {
  return {
    type: RECEIVE,
    payload: {
      data
    }
  };
}

export function resetLightweightProfile() {
  return (dispatch) => {
    dispatch({
      type: RESET
    });
  };
}

function validateChannels(channels: Array<ChannelForm>): Promise<void | Array<ChannelForm>> {
  if (channels.length === 0) {
    return Promise.resolve(channels);
  }

  return new Promise((resolve, reject) => {
    Promise.all(channels.map(channel => validateChannelUrl(channel.url)))
      .then(channelValidationResults => {
        const hasInvalidChannels = channelValidationResults.some(channel => !channel);

        if (hasInvalidChannels) {
          reject('profile_not_found'); // eslint-disable-line prefer-promise-reject-errors
          return;
        }

        resolve();
      });
  });
}

export function createLightweightProfile(profileDetails, organizationId) {
  return (dispatch, getState) => {
    const selectedOrganizationId = organizationId || getState().organizations.currentOrganizationId;
    const url = createLightweightInfluencerProfileEndpoint(selectedOrganizationId);

    dispatch(showLoading(url));

    return validateChannels(profileDetails.channels)
      .then(() => post(url, { data: profileDetails }))
      .then(response => {
        const influencerProfile = response.data;

        dispatch(receiveLightweightProfile(influencerProfile));
        dispatch(hideLoading(url));

        return influencerProfile;
      })
      .catch(error => {
        let errorStatus = (error && error.response && error.response.data.code) ? error.response.data.code : error;
        errorStatus = (errorStatus || '').replace(/\./g, '_');
        const message = __t(`lightweight_profile_reducer.${errorStatus}`)
          || __t('lightweight_profile_reducer.common');
        dispatch(receiveError(message));
        dispatch(hideLoading(url));

        throw error;
      });
  };
}

export default createReducer<any, any>('lightweightProfile', initialState, {
  [RESET_ON_LOGOUT]: () => initialState,
  [RESET]: () => initialState,
  [RECEIVE_ERROR]: (state, { data }) => ({
    ...state,
    errorMessage: data
  }),
  [RECEIVE]: (state, { data }) => ({
    errorMessage: '',
    profile: data
  })
});
